import _isEmpty from 'lodash/isEmpty';

/**
 * Normalize AJV8 validation message wording to match AJV6 phrasing.
 * - Rewrites "must NOT" → "should NOT"
 * - Rewrites maxLength phrasing: "have more than N characters" → "be longer than N characters"
 * - Rewrites minLength phrasing: "have fewer than N characters" → "be shorter than N characters"
 * Guards against undefined error.message.
 *
 * @param   {string|undefined}  message  The error message to normalize
 * @return  {string}                     Normalized message
 */
export const normalizeAjv8Message = message =>
    (message || '')
        .replace('must NOT', 'should NOT')
        .replace(/have more than (\S+) characters/, 'be longer than $1 characters')
        .replace(/have fewer than (\S+) characters/, 'be shorter than $1 characters');

/**
 * Get enum values from list to schema form options.
 *
 * @method getFormEnumSchema
 * @param  {Array}          list        The original list
 * @param  {string}         enumKey key to enum array
 * @param  {string}         enumNameKey key to enumName array
 * @return {Array}
 */
export function getFormEnumSchema(list, enumKey, enumNameKey) {
    if (!_isEmpty(list)) {
        const { enums, enumNames } = list.reduce(
            (accumulator, option) => {
                return {
                    enums: [...accumulator.enums, option[enumKey]],
                    enumNames: [...accumulator.enumNames, option[enumNameKey]],
                };
            },
            { enums: [], enumNames: [] }
        );

        return { enums, enumNames };
    } else {
        return { enums: [], enumNames: [] };
    }
}
